import {ComponentProps} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {CloseIconButton} from "../../../../atoms/CloseIconButton";
import {AskForFullOfferForm} from "./AskForFullOfferForm";

type IProps = Omit<ComponentProps<typeof AskForFullOfferForm>, "customHeader">;

export const LeadModalAskForFullOfferForm = (props: IProps) => {
    const {handleModalClose} = props;

    return (
        <div className={containerStyles}>
            <div className={innerContainerStyles} data-testid={OFFER_TEST_IDS.LEAD_FORM.ASK_FOR_FULL_OFFER_FORM}>
                <CloseIconButton className={closeButtonStyles} onClick={handleModalClose} size="1.6" />

                <AskForFullOfferForm
                    {...props}
                    customHeader={
                        <Text variant="headline_4" as="p" mb={3} align="center">
                            Zapytaj dewelopera o pełną ofertę
                        </Text>
                    }
                    isTwoColumnGrid
                />
            </div>
        </div>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "544px",
        h: "auto",
        overflow: "visible"
    }
});

const innerContainerStyles = css({
    p: 3
});

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});
import {ComponentProps} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {CloseIconButton} from "../../../../atoms/CloseIconButton";
import {AskForFullOfferForm} from "./AskForFullOfferForm";

type IProps = Omit<ComponentProps<typeof AskForFullOfferForm>, "customHeader">;

export const LeadModalAskForFullOfferForm = (props: IProps) => {
    const {handleModalClose} = props;

    return (
        <div className={containerStyles}>
            <div className={innerContainerStyles} data-testid={OFFER_TEST_IDS.LEAD_FORM.ASK_FOR_FULL_OFFER_FORM}>
                <CloseIconButton className={closeButtonStyles} onClick={handleModalClose} size="1.6" />

                <AskForFullOfferForm
                    {...props}
                    customHeader={
                        <Text variant="headline_4" as="p" mb={3} align="center">
                            Zapytaj dewelopera o pełną ofertę
                        </Text>
                    }
                    isTwoColumnGrid
                />
            </div>
        </div>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "544px",
        h: "auto",
        overflow: "visible"
    }
});

const innerContainerStyles = css({
    p: 3
});

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});
